import React from 'react';
import ReactModal from 'react-modal';
import PropTypes from 'prop-types';
import {I18nextProvider} from 'react-i18next';
import i18next from './locales/i18next';
import {CloseButton} from './CloseButton';
import style from './style.module.scss';
import IFrameFocusManager from '../IFrameFocusManager';

ReactModal.setAppElement('#container');

const i18n = i18next;
const changeLang = (lang) => {
  i18n.changeLanguage(lang);
};

/**
 * Modal:
 *  - Modal window component based on react-modal package
 */
export function Modal(props) {

  React.useEffect(() => {
    props.lang && changeLang(props.lang);
  }, [props.lang]);

  const renderCloseButton = () =>
    props.closeButton ? (
      <I18nextProvider i18n={i18n}>
        <CloseButton className={props.className} close={props.close} lang={props.lang} />
      </I18nextProvider>
    ) : null;

  const contentClass = `${style.modal_content} ${props.className} ${props.className}_content`;

  const overlayClass =
    `${style.modal_overlay} ${props.notebookExpanded?style.notebook_expanded:''} ${props.fullScreen?style.full_screen:''} ${props.className}_overlay ${props.hideBackground? style.modal_overlay_background: ''}`;

  return (
    <ReactModal
      aria={{
        label: props.ariaLabel,
      }}
      parentSelector={props.parentElement? () => document.querySelector(`#${props.parentElement}`) : undefined}
      className={contentClass}
      overlayClassName={overlayClass}
      isOpen={props.isOpen}
      onRequestClose={props.close}
      shouldCloseOnOverlayClick={props.closeOnOverlayClick}>
        <div style={{position: 'relative'}}>
          <IFrameFocusManager>
            {renderCloseButton()}
            {props.children}
          </IFrameFocusManager>
        </div>
    </ReactModal>
  );
}

Modal.propTypes = {
  /**
   * Boolean set/reset to open/close modal
   */
  isOpen: PropTypes.bool.isRequired,
  /**
   * Fuction to close modal
   */
  close: PropTypes.func,
  /**
   * Component/Components to display on Modal
   */
  children: PropTypes.oneOfType([PropTypes.element, PropTypes.array]),
  /**
   * Close Modal window when cliked on overlay
   */
  closeOnOverlayClick: PropTypes.bool,
  /**
   * ClassName for overlay and content tags
   */
  className: PropTypes.string,
  /**
   * Show closeButton or not
   */
  closeButton: PropTypes.bool,
  /**
   * Notebook area expanded state
   */
  notebookExpanded: PropTypes.bool,
  /**
   * Notebook area full-screen state
   */
  fullScreen: PropTypes.bool,
  /**
   * renders a background image instead of blured background. 
   */
  hideBackground: PropTypes.bool,
  /**
   * Necessary for logging to have context of the simulation, changes where the modal renders. 
   */
  parentElement: PropTypes.string
};

Modal.defaultProps = {
  isOpen: false,
  closeOnOverlayClick: false,
  className: '',
  closeButton: false,
  notebookExpanded: false,
  fullScreen: false,
  hideBackground: false
};
